import React from 'react';
import styles from './Select.module.css';

export default function Select({
  children,
  className = '',
  label,
  error,
  id,
  ...rest
}) {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return (
    <div className={`${styles.field} ${className}`}>
      {label && <label htmlFor={selectId} className={styles.label}>{label}</label>}
      <select id={selectId} className={`${styles.select} ${error ? styles.error : ''}`} {...rest}>
        {children}
      </select>
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
}
